import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const FacebookBanner = () => {
  const [conn, setConn] = useState(null);
  useEffect(() => { api.fbConnection().then(setConn).catch(() => {}); }, []);
  if (!conn || conn.connected) return null;
  return (
    <div className="card-surface flex flex-wrap items-center gap-4 px-5 py-4 border-l-4 !border-l-[#1877f2]" data-testid="fb-banner">
      <span className="w-10 h-10 rounded-xl bg-[#1877f2] grid place-items-center shrink-0"><Facebook className="w-5 h-5 text-white" fill="white" /></span>
      <div className="flex-1 min-w-[200px]">
        <p className="font-semibold text-sm">Publiez vos vidéos sur votre page Facebook</p>
        <p className="text-xs text-[#65676b]">Connectez votre page une fois : BuzzlyMe y publiera chaque nouvelle vidéo automatiquement.</p>
      </div>
      <Link to="/app/profile" className="btn-primary" data-testid="fb-banner-connect-btn">Connecter ma page Facebook <ArrowRight className="w-4 h-4" /></Link>
    </div>
  );
};
